const _temp0 = require("./chapter.view.less");

const _temp1 = require("./layout.view.less");

const _temp2 = require("./overview.view.less");

module.exports = {
  "chapter":   {
    "less": _temp0
  },
  "layout":   {
    "less": _temp1
  },
  "overview":   {
    "less": _temp2
  }
}